export default function () {
  const preloaderEl = window.document.querySelector('.c-preloader');
  const bookingLayout = window.document.querySelector('booking-layout');

  function bookingPageLoaded() {
    if (!bookingLayout) {
      return;
    }

    window.document.addEventListener('azdsBookingReady', () => {
      preloaderEl.style.opacity = 0;
      document.dispatchEvent(new CustomEvent('preloader:done', { bubbles: true }));
    });
  }

  function regularPageLoaded() {
    if (bookingLayout) {
      return;
    }

    window.addEventListener('load', () => {
      preloaderEl.style.opacity = 0;
      document.dispatchEvent(new CustomEvent('preloader:done', { bubbles: true }));
    });
  }

  if (preloaderEl) {
    regularPageLoaded();
    bookingPageLoaded();

    preloaderEl.addEventListener('transitionend', () => {
      preloaderEl.remove();
    }, { once: true });
  }
}
